import type { SVGComponentProps } from 'BreetHelpers';

export const HourGlassIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='11'
		height='19'
		viewBox='0 0 11 19'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M9.59227 4.625V0H1.0332V4.625C1.0332 6.33344 2.02078 7.80875 3.45148 8.50359C3.77469 8.66055 3.98461 8.98523 3.98461 9.34703V9.40305C3.98461 9.76484 3.77469 10.0895 3.45148 10.2465C2.02078 10.9413 1.0332 12.4166 1.0332 14.1251V18.75H9.59227V14.125C9.59227 12.4166 8.60469 10.9413 7.17398 10.2464C6.85078 10.0895 6.64086 9.76477 6.64086 9.40297V9.34695C6.64086 8.98516 6.85078 8.66055 7.17398 8.50352C8.60469 7.80875 9.59227 6.33352 9.59227 4.625Z'
			fill='#FFEACF'
		/>
		<path
			d='M8.96681 14.3543C8.83735 14.3543 8.73243 14.2494 8.73243 14.12C8.73243 12.804 7.97313 11.5851 6.79806 11.0144C6.68165 10.9579 6.63306 10.8176 6.68962 10.7012C6.74626 10.5848 6.88642 10.5363 7.00282 10.5928C8.33829 11.2413 9.20118 12.6258 9.20118 14.1199C9.20118 14.2494 9.09626 14.3543 8.96681 14.3543Z'
			fill='#FCF9DE'
		/>
		<path
			d='M5.63898 10.2464C5.96219 10.0894 6.17211 9.76477 6.17211 9.40297V9.34695C6.17211 8.98516 5.96219 8.66055 5.63898 8.50352C4.20828 7.80867 3.2207 6.33344 3.2207 4.62492V0H1.0332V4.625C1.0332 6.33344 2.02078 7.80875 3.45148 8.50359C3.77469 8.66063 3.98461 8.98523 3.98461 9.34703V9.40305C3.98461 9.76484 3.77469 10.0895 3.45148 10.2465C2.02078 10.9413 1.0332 12.4166 1.0332 14.1251V18.75H3.2207V14.125C3.2207 12.4166 4.20828 10.9413 5.63898 10.2464Z'
			fill='#FFD59A'
		/>
		<path
			d='M2.14893 6.22766C2.73096 7.3886 3.92463 8.18696 5.30041 8.18696H5.32408C6.69986 8.18696 7.89354 7.3886 8.47557 6.22766H2.14893Z'
			fill='#F9BB32'
		/>
		<path
			d='M8.85435 17.5348V16.9525C8.85435 14.9897 7.27092 13.3929 5.32451 13.3929H5.30084C3.35451 13.3929 1.771 14.9897 1.771 16.9525V17.5348H8.85435Z'
			fill='#F9BB32'
		/>
		<path
			d='M5.625 7.44421H5V13.6942H5.625V7.44421Z'
			fill='#F9BB32'
		/>
		<path
			d='M3.22061 14.1202C3.22061 14.1046 3.22131 14.0892 3.22146 14.0736C2.34303 14.7217 1.771 15.7683 1.771 16.9475V17.5299H3.22068L3.22061 14.1202Z'
			fill='#DB9C2E'
		/>
		<path
			d='M5 10.6334C5.19648 10.491 5.40555 10.3652 5.625 10.2576V8.50086C5.40555 8.39328 5.19648 8.2675 5 8.125V10.6334Z'
			fill='#DB9C2E'
		/>
		<path
			d='M5.08041 8.17961C4.38791 7.70172 3.84244 7.02352 3.52588 6.22766H2.14893C2.69971 7.32625 3.79822 8.09969 5.08041 8.17961Z'
			fill='#DB9C2E'
		/>
		<path
			d='M10.1805 1.64798H0.444531C0.198985 1.64798 0 1.44892 0 1.20345V0.45564C0 0.210093 0.199063 0.0111084 0.444531 0.0111084H10.1805C10.426 0.0111084 10.625 0.210171 10.625 0.45564V1.20345C10.625 1.44892 10.4259 1.64798 10.1805 1.64798Z'
			fill='#BF6C0D'
		/>
		<path
			d='M0.444531 17.0983H10.1805C10.426 17.0983 10.625 17.2973 10.625 17.5428V18.2906C10.625 18.5362 10.4259 18.7351 10.1805 18.7351H0.444531C0.198985 18.7351 0 18.5361 0 18.2906V17.5428C0 17.2973 0.199063 17.0983 0.444531 17.0983Z'
			fill='#BF6C0D'
		/>
		<path
			d='M4.30566 3.44849C4.69399 3.44849 5.00879 3.13369 5.00879 2.74536C5.00879 2.35704 4.69399 2.04224 4.30566 2.04224C3.91734 2.04224 3.60254 2.35704 3.60254 2.74536C3.60254 3.13369 3.91734 3.44849 4.30566 3.44849Z'
			fill='#FFD59A'
		/>
		<path
			d='M4.30566 16.875C4.69399 16.875 5.00879 16.5602 5.00879 16.1719C5.00879 15.7835 4.69399 15.4688 4.30566 15.4688C3.91734 15.4688 3.60254 15.7835 3.60254 16.1719C3.60254 16.5602 3.91734 16.875 4.30566 16.875Z'
			fill='#DB9C2E'
		/>
		<path
			d='M2.1875 1.20345V0.455718C2.1875 0.210093 2.38656 0.0111084 2.63203 0.0111084H0.444531C0.198985 0.0111084 0 0.210171 0 0.455718V1.20345C0 1.449 0.199063 1.64798 0.444531 1.64798H2.63203C2.38656 1.64798 2.1875 1.44892 2.1875 1.20345Z'
			fill='#A56021'
		/>
		<path
			d='M2.1875 18.2905V17.5428C2.1875 17.2972 2.38656 17.0983 2.63203 17.0983H0.444531C0.198985 17.0983 0 17.2973 0 17.5428V18.2905C0 18.5362 0.199063 18.7351 0.444531 18.7351H2.63203C2.38656 18.7351 2.1875 18.5362 2.1875 18.2905Z'
			fill='#A56021'
		/>
	</svg>
);
